/**
 * Where this package's diagnostics go, if anywhere.
 *
 * Namespacing, filtering, and whether any of it leaves the browser are decisions an app has already made — so this asks for
 * somewhere to write rather than deciding. `console` satisfies it, and so does any logger with these three methods.
 *
 * Nothing is logged when no logger is supplied.
 */
export interface WhipLogger {
	debug(...args: unknown[]): void;
	warn(...args: unknown[]): void;
	error(...args: unknown[]): void;
}

const noop = () => {};

/** Silence, so every call site can log unconditionally. */
export const SILENT: WhipLogger = { debug: noop, warn: noop, error: noop };
